export const FETCH_DASHBOARD_DATA = "FETCH_DASHBOARD_DATA";
export const FETCH_DASHBOARD_GLOBAL_SEARCH = "FETCH_DASHBOARD_GLOBAL_SEARCH";
export const FETCH_DASHBOARD_SYNC_USERS_BY_CRM =
  "FETCH_DASHBOARD_SYNC_USERS_BY_CRM";
